export enum MainPage {
  Swap = 'index',
  Convert = 'convert',
  Auction = 'auction',
  NinjaPass = 'ninja-pass',
  Incentives = 'incentives',
  GridTrading = 'grid-trading',
  GridTradingContract = 'grid-trading-contract'
}
